// extracted by mini-css-extract-plugin
export default {"search-box":"V_fY","search-box__input":"V_fZ form-control","search-box__icon":"V_f0 ml-2"};